/**
 * Research domain event schemas.
 *
 * Typed payload validation for deep research and related Mycelium events.
 * Rule: fields added after initial release MUST be `.optional()`.
 *
 * @module research.events
 * @since 2026-05-25
 */

import { z } from 'zod'
import { BackboneEventSchema } from '../types/backbone.ts'

/** Shared payload for deep research completion / failure (PGMQ + specialists). */
export const DeepResearchCompletionPayloadSchema = z.object({
  tool: z.string(),
  query: z.string().optional(),
  topic: z.string().optional(),
  interactionId: z.string().optional(),
  taskId: z.string().optional(),
  status: z.string(),
  summary: z.string().optional(),
  reportLength: z.number().optional(),
  curateRequested: z.boolean().optional(),
  credentialType: z.string().optional(),
  source: z.string(),
  timestamp: z.string().optional(),
  resultCount: z.number().optional(),
  searchTime: z.number().optional(),
  provider: z.string().optional(),
  confidence: z.number().optional(),
})

export type DeepResearchCompletionPayload = z.infer<typeof DeepResearchCompletionPayloadSchema>

export const DeepResearchCompletedEvent = BackboneEventSchema.extend({
  domain: z.literal('research'),
  type: z.literal('research.deep_research.completed'),
  payload: DeepResearchCompletionPayloadSchema,
})

export const DeepResearchFailedEvent = BackboneEventSchema.extend({
  domain: z.literal('research'),
  type: z.literal('research.deep_research.failed'),
  payload: DeepResearchCompletionPayloadSchema,
})

export const ResearchDomainEvents = [
  DeepResearchCompletedEvent,
  DeepResearchFailedEvent,
] as const
